import { DUR } from '@/animations/settings/vars'
import { cn } from '@/lib/utils'
import { Typo3Page, Typo3SectionSpotHeadlessHero } from '@/types'
import {
  Base,
  Breadcrumbs,
  Container,
  Div,
  RatingStars,
  Richtext,
  Section,
  Title
} from '@/ui/components'
import { memo } from 'react'
import SlideImage from './components/SlideImage'

interface SectionHeroProps {
  pageData: Typo3Page
  data: Typo3SectionSpotHeadlessHero
}

const SectionHero = ({ data, pageData }: SectionHeroProps) => {
  const haveImage =
    data?.appearance?.layout === 'default' &&
    data?.images &&
    data?.images?.length > 0

  const disableAnimation = data?.appearance?.disableAnimation

  if (pageData?.appearance?.layout === 'page-without-header') {
    return null
  }

  return (
    <Section
      data={data}
      className={cn(
        's-section-hero pb-xl',
        data.images?.length ? 'pt-none' : 'pt-4xl'
      )}
    >
      {data.images?.length ? (
        <Base anim={disableAnimation ? undefined : 'fade-in'}>
          <SlideImage data={data} />
        </Base>
      ) : null}
      <div
        className={cn(
          'relative z-10 flex flex-col items-start',
          haveImage && 'md:-mt-14'
        )}
      >
        <Breadcrumbs
          data={pageData}
          anim={disableAnimation ? undefined : 'fade-in'}
          haveImage={haveImage}
          animVars={{ delay: DUR.stagger * 1 }}
        />

        <Div
          className={cn(
            'bg-accent-300 py-md pr-lg pl-padding-lg wrap-break-word text-neutral-100 md:max-w-10/12 lg:max-w-7/12'
          )}
          anim={disableAnimation ? undefined : 'fade-in'}
          animVars={{ delay: DUR.stagger * 2 }}
        >
          {data?.stars && <RatingStars stars={data?.stars} />}
          <Title className="h1">{data?.title}</Title>
        </Div>
        {data?.hasText && data?.text && (
          <Container
            className="pt-lg text-neutral-600"
            anim={disableAnimation ? undefined : 'fade-in'}
            animVars={{ delay: DUR.stagger * 3 }}
          >
            <Richtext className="h5 mr-auto max-w-[55.6rem]" text={data.text} />
          </Container>
        )}
      </div>
    </Section>
  )
}

SectionHero.displayName = 'SectionHero'

export default memo(SectionHero)
